import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { VolunteerSpecialistPool } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(service: VolunteeringAreaService, util: UtilityService, domainData: DomainDataService, dialogService: DialogService, app: AppService): GridSetup<VolunteerSpecialistPool> {

	return {
		rowName: { singular: 'Specialist', plural: 'Specialists' },
		getRowKey: row => '' + row.volunteerId,
		stateKey: 'specialist-pool-grid',
		actions: getActions(service, dialogService),
		buttons: [],
		columns: getColumns(util, domainData, app, service),
	}
}
